import { Injector } from '@angular/core';
import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { ColumnsComponent } from './columns.component';
import { COLUMNS_NODE_NAME, COLUMN_NODE_NAME } from './columns.model';

const columnsClassName = 'columns-block';

export const ColumnsExtension = (injector: Injector) => {
  return Node.create({
    name: COLUMNS_NODE_NAME,
    content: `${COLUMN_NODE_NAME}{2,3}`,
    group: 'block',
    defining: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        custom_css: {
          default: '',
        },
        custom_style: {
          default: null,
        },
        show_borders: {
          default: false,
        },
        column_widths: {
          default: null,
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== columnsClassName);
            return { class: `${columnsClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [{ tag: `div.${columnsClassName}` }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: columnsClassName }, HTMLAttributes), 0];
    },

    addNodeView() {
      return AngularNodeViewRenderer(ColumnsComponent, {
        injector,
        stopEvent: ({ event }) => {
          const target = event.target as HTMLElement;
          // Stop ProseMirror from handling events on the resize handle and controls
          if (target.closest('.column-resize-handle') || target.closest('.columns-controls')) {
            return true;
          }
          return false;
        },
      });
    },
  });
};
